module.exports = __webpack_public_path__ + "img/bubble_layout_1.1bdba07e.png";